module.exports = __webpack_public_path__ + "img/contentUs-phone-icon.746ab842.svg";